// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Мол за данни",
        "pull_refresh": "Издърпайте се, за да се опресните",
        "release_refresh": "Освобождаване за опресняване",
        "refresh_loading": "Зареждане ...",
        "footer_text": "Услугите се предоставят от Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Страна/регион за търсене",
        "my_flow": "Моите данни",
        "charge_code": "Ваучер код",
        "coupons": "Купони",
        "local_package": "Локални данни",
        "more": "Още",
        "popular_destination": "Държава/регион",
        "buy_now":"Купете сега",
        "package_useing": "Активен",
        "unused": "Неактивен",
        "download_app": "Изтеглете приложението",
        "enter_the_mall_list": "Влезте в списъка на мола",
        "no_data": "Все още няма данни",
        "no_data_available": "Няма налични данни",
        "copy_success": "Копиране успешно",
        "copy_fail": "Неуспешно копиране",
        "meritsTitle": "Какви са предимствата?",
        "merits1": "Без нужда от SIM & Без месечни такси",
        "merits2": "Интегрирано с най-добрите 2-3 оператора за автоматично превключване на мрежа",
        "go_buy": "Купете сега",
        "instant_savings": "Спестяване",
        "expires_in": "Изтича след",
        "download_app_tips": "Изтеглете приложението за повече оферти и преживявания"
    },
    "packages": {
        "sub_title": {
            "us": "С изключение на Гуам, Сайпан",
            "it": "Включително Ватикана Сити, Сан Марино",
            "va": "Включително Италия, Сан Марино",
            "sm": "Включително Италия, Ватикана Сити",
            "ma": "Включително Западна Сахара",
            "eh": "Включително Мароко",
            "ch": "Включително Лихтенщайн",
            "li": "Включително Швейцария",
            "fr": "Включително Монако",
            "mc": "Включително Франция",
            "fi": "Включително островите Аланд",
            "ax": "Включително Финландия",
            "gu": "Включително островите на Северна Мариана",
            "mp": "Включително Гуам"
        },
        "unlimited_packages": "Неограничен пакет от данни",
        "normal_packages": "Нормален пакет от данни",
        "multi_region_packages": "Мултирегион",
        "regional_data": "Регионални данни",
        "high_speed_text": "Данни с висока скорост",
        "infiniteFlow": "Неограничени данни",
        "unLimitData": "Безлимитен",
        "high_speed_text_year": "Висока скорост/MP",
        "package_list": "Списък с пакети",
        "special_offer": "Промоции",
        "first_month": "1 Месец",
        "periodUnit": {
            "day": "Ден (и)",
            "month": "месец",
            "hour": "час (и)",
            "year": "година"
        },
        "periodUnits": {
            "day": "Ден (и)",
            "month": "месеци",
            "hour": "час (и)",
            "year": "години"
        },
        "periodUnitSimp": {
            "day": "г",
            "month": "за",
            "hour": "з",
            "year": "the"
        },
        "periodUnitMonthly":"Месечен",
        "periodUnitsSimp": {
            "day": "г",
            "month": "за",
            "hour": "з",
            "year": "the"
        },
        "unlimited_good_name": {
            "day": "Дневен пропуск",
            "month": "Месечен пропуск",
            "year": "Годишно преминаване"
        },
        "continuousMonth": "Непрекъснати месеци",
        "continuousDay": "Непрекъснати дни",
        "continuousYear": "Непрекъснати години",
        "day_invalid": "Изтича в текущия ден",
        "month_invalid": "Изтича в текущия месец",
        "immediate_valid": "В сила незабавно",
        "tomorrow_day_valid": "В сила от следващия ден",
        "tomorrow_month_valid": "В сила от следващия месец",
        "detail": {
            "cell_flow": "Данни",
            "cell_period": "Валидност",
            "buy_quantity": "Сума",
            "use_area": "Покритие",
            "use_intro": "Общи условия",
            "buy_btn": "Поръчка",
            "pay": "Плащане",
            "buy_tips": "Имате пакет %@packageName в употреба. Искате ли да закупите този пакет?",
            "haveOrderTips": "Създадена поръчка с изчакване на плащане. Натиснете Потвърди за преминаване към моята страница с данни！"
        },
        "confirm": {
            "title": "Потвърждение за поръчка",
            "real_pay_amount": "Изплатена сума",
            "online_payment": "Онлайн плащане",
            "create_order_error": "Настройката не успя"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Получаване на състояние на поръчка ...",
            "buy_success": "Поръчайте пълна",
            "buy_pending": "В очакване на потвърждение",
            "buy_pending_tip": "Плащане в процес ... Ако плащането не се прехвърли в рамките на 10 минути, моля, свържете се с нас за поддръжка.",
            "get_payment_info_fail": "Придобиването на информация за плащане не бе успешно",
            "cell_package": "Пакет",
            "cell_buy_amount": "Субтотален",
            "cell_real_amount": "Изплатена сума",
            "go_to_order_btn": "Отидете в моя пакет",
            "back_home": "Обратно вкъщи",
            "back_mall": "Обратно в мола",
            "ordersn_empty": "Поръчката SN не може да бъде празна",
            "order_search_error": "Неочаквана грешка",
            "goodsName": 'Име на продукта'
        },
        "fail": {
            "payment_fail": "Плащането не бе успешно",
            "back_home": "Обратно вкъщи"
        }
    },
    "CountryGroup": {
        "title": "Държава/регион",
        "placeholder": "Страна или регион за търсене",
        "clear": "Ясно",
        "history": "История на търсенето"
    },
    "PromotionCode": {
        "verification": {
            "title": "Ваучер код",
            "minititle": "Ваучер код",
            "input": "Моля, въведете кода за допълване",
            "explain": "Съвети: Докоснете бутона за сканиране в горния десен QR код на ваучера или ръчно въведете кода на ваучера (чувствителен към случая), ако той не работи.",
            "submit": "Изпратете",
            "exchange": "Изкупи",
            "cancel": "Отказ",
            "Inquiry": "Сигурни ли сте, че обменяте ли",
            "ErrorCode": "Грешка в кода за презареждане"
        },
        "recharge_success": {
            "package": "Пакет",
            "content": "Успешно изкупени",
            "back": "Обратно към търговския център",
            "view_packets": "Отидете в моя пакет"
        }
    },
    "order": {
        "state": {
            "inUse": "Активиран",
            "isFirst": "Приоритизиран",
            "toFirst": "Задайте приоритет",
            "inactive": "Инактивиран"
        },
        "periodUnits": {
            "minute": "минута (и)",
            "hour": "час (и)",
            "day": "Ден (и)",
            "month": "месец (и)"
        },
        "useIntro": {
            "tip1": "Неограниченият пакет от данни има по -висок приоритет от пакета с данни за обем.",
            "tip2": "Приоритетът на използването ще се основава на датата на покупка за същия тип пакет, т.е. пакетът с най-ранната дата на покупка ще бъде използван първо, докато приоритетът на еднорегионните пакети е по-висок от регионалния пакет.",
            "tip3": "Можете също така ръчно да регулирате приоритета на използването на пакети от същия тип."
        },
        "myFlow": "Моите данни",
        "remainingFlow": "Данни останали",
        "remainingTime": "Валиден вляво",
        "remainingHighFlow": "Данни с висока скорост оставени",
        "validPeriod": "Валидност",
        "noneFlow": "Няма пакет от данни",
        "noneFlowTip": "Моля, закупете пакета с данни и се насладете на висококачествената мрежа",
        "buyPackFlow": "Купете пакети",
        "checkInvalidFlow": "Проверете пакета с изтекли данни",
        "orderList": {
            "title": "моите заповеди",
            "amount_paid": "Общо",
            "device": "Собствено устройство",
            "order_details": "Подробности за поръчката",
            "total_amont": "Междинна сума",
            "orderSN": "Поръчка №",
            "createTime": "Време на създаване",
            "cancelTime": "Затворено време",
            "payTime": "Време за поръчка",
            "unsubTime": "Отменен час",
            "payMethod": "Начин на плащане",
            "thirdSN": "Транзакция №",
            "delete": "Изтриване",
            "cancel": "Отказ от поръчката",
            "unsub": "Възстановяване на средства",
            "goto_cancel": "Искате ли да отмените поръчката?",
            "goto_unsubscribe": "Искате ли да отпишете поръчката?",
            "delete_Tips": "Поръчката не може да бъде възобновена, след като бъде изтрита, следователно вашите проблеми след обслужването не могат да бъдат обработени.Сигурни ли сте, че ще го изтриете?",
            "status_success": "Завършено",
            "status_pending": "Неплатени",
            "status_cancel": "Затворено",
            "status_unsub": "Отменено",
            "payMethod_stripe": "Кредитна карта"
          },
    },
    "registerlogin": {
        "create_account_tip":"Създайте акаунт, стартирайте ексклузивно преживяване",
        "select_country_tip":"Използване на устройството държава/регион",
        "email_name": "Поща",
        "phone_name": "Телефон",
        "email_address": "Имейл адрес",
        "password": "парола",
        "country": "държава",
        "select_country": "Изберете държава",
        "cancel": "Отказ",
        "confirm": "Сигурно",
        "please_enter": "Моля, въведете 6-20 знака (комбинация от букви, цифри или символи)",
        "select_country_tips": "Изборът на държава е за гледане на местни пакети. Тя не може да бъде променена след регистрация. Моля, потвърдете!",
        "global_roaming": "Международен код на домейни",
        "phone_number": "телефонен номер",
        "agree": "Съгласен съм",
        "user_agreement": "Потребителски споразумение",
        "and": "и",
        "privacy_policy": "Политика за поверителност",
        "register_login": "Регистрирайте се или влезте",
        "login_error": "Броят на входите е твърде чест, моля, опитайте отново по -късно!",
        "register_error": "Броят на регистрациите е твърде чест, моля, опитайте отново по -късно!",
        "forgot_pwd": "Забравете паролата",
        "app_tips": "Влезте в приложението с този акаунт, след като го изтеглите, за да получите достъп до повече функции.",
        "download_app": "Отидете да изтеглите приложението",
        "rememberPwd": "Запомнете паролата",
        "third_login": "Продължете с",
        "agreement_tips": "Моля, проверете Потребителското споразумение и Политиката за поверителност",
        "selectCountry_tips": "Моля, обърнете внимание, че регистрираната държава ще повлияе пряко на следните методи на плащане и валути, моля, изберете според вашите нужди.",
        "login_error_cancel": "Потребителят отказа вписването",
        "login_error_auth": "Разрешете изскачащи прозорци от настройките на браузъра",
        "device_tips": "Устройство чака активиране. Обработка в рамките на 24 часа."
    },
    "forgotPwd": {
        "forgot_pwd": "Забравете паролата",
        "email_address": "Имейл адрес",
        "next": "След това",
        "email_has_been_sent": "Изпратихме имейл до %@email. Моля, кликнете върху връзката и следвайте стъпките, за да извлечете паролата си.",
        "have_retrieved_it": "Намерих го",
        "unable_to_receive_email": "Не можете да получите имейла? Моля, проверете дали има имейли от %@email под вашия спам и изтрита поща директория",
        "or": "или",
        "resend": "Възстановяване",
        "global_roaming": "Международен код на домейни",
        "phone_number": "телефонен номер",
        "verification_code_has_been_sent": "Изпратихме кода за проверка на:",
        "verification_code": "Код за проверка",
        "no_verification_code_received": "Не получи ли кода за проверка?",
        "please_enter": "Моля, въведете 6-20 знака (комбинация от букви, цифри или символи)",
        "reset_password": "Нулиране на паролата",
        "reset_successful": "Нулиране успешно"
    },
    "coupons": {
        "coupons_name": "Купони",
        "no_coupons": "Все още няма купони",
        "no_data": "Все още няма данни",
        "applicable_to_the_following": "Купоните са подходящи за следния пакет от данни"
    },
    "digital":{
        "title":"Устройство SN",
        "purchased":"Моите покупки",
        "viewAll":"Още",
        "skinStore":"Магазин за продукти",
        "completed":"Закупени",
        "goBuy":"Купете",
        "order": {
          "title":"Закупени поръчки"
        },
        "detail": {
          "describe":"Описание"
        }
    },    
    "viewPL": {
        "other": 'други'
    },
    "invalidFlow": {
        "stateName": "Статус",
        "state": {
            "NOT_ACTIVATED": "Инактивиран",
            "IN_USING": "На разположение",
            "USE_END": "Изтощен",
            "EXPIRE": "Изтече",
            "TRANSFER": "Трансфер",
            "UNSUBSCRIBE": "Отказ",
            "VALID": "Валиден",
            "INVALID": "Невалиден",
            "EXCHANGE_POINTS": "Изкупи точки"
        },
        "noneFlow": "Без пакет от данни с изтекъл срок на годност",
        "pageName": "Пакет с изтекли данни"
    },
    "flowDetail": {
        "title": "Подробности за данните",
        "flow": "Данни",
        "validTime": "Валидни стартове",
        "invalidTime": "Валидно до",
        "coverage": "Покритие",
        "useIntro": "Общи условия",
        "purchaseTime": "Закупен на",
        "subtotal": "Субтотален",
        "status": "Статус",
        "cancel": "Отказ",
        "buyAgain": "Купете го отново",
        "validity": "Валидност",
        "tip": "Забележете",
        "cancelTip": "Сигурни ли сте, че искате да възстановите този пакет?",
        "dataLeft": "Данни останали"
    },
    "netError": {
        "try_again": "Опитайте отново",
        "net_error": "Няма мрежа",
        "try_again_desc": "Моля, проверете настройката на мрежата и опитайте отново"
    },
    "loadFail": {
        "try_again": "Опитайте отново",
        "load_fail": "Зареждането не успя",
        "load_fail_desc": "Зареждането на данни не успя, моля, опитайте отново",
        "IMEI_Not_Exist": "Imei не съществува, моля, опитайте се да влезете от десния вход",
        "Project_Not_Exist": "Възниква грешка. Моля, свържете се с обслужване на клиенти. (01)",
        "commonError": "Възниква грешка. Моля, свържете се с обслужване на клиенти."
    },
    "settlement_Easy_and_convenient": "Лесен и удобен",
    "settlement_Great_deal": "Страхотна сделка",
    "settlement_Safe_and_secure": "Безопасно и сигурно",
    "settlement_Autopay_service_regulation": "Регулиране на услугата за автоматично плащане",
    "settlement_Read": "Прочетете",
    "settlement_No_coupon": "Няма наличен купон",
    "settlement_Subtotal": "Субтотален",
    "settlement_Coupon": "Купони",
    "settlement_TOTAL": "Общо",
    "settlement_promotion_tip": "Промоционалната оферта не може да се използва заедно с талони",
    "settlement_coupon_tip": "Купонът не може да се използва заедно с други промоционални оферти",
    "member_myFlow_noList": "Без данни",
    "detail_se_content": "Сигурен, лесен и удобен начин. Можете да се отпишете по всяко време",
    "Enter_Promo_code": "Код за промоция",
    "Enter_Promo_Coupon": "Купони",
    "settlement_Not_used_coupon": "Купонът не се използва",
    "settlement_Available_coupon": "На разположение",
    "settlement_Unavailable_coupon": "Недостъпни",
    "please_Enter_Promo_code": "Моля, въведете кода за промоция",
    "please_Select_Coupon_use": "Моля, изберете купона, който искате да използвате.",
    "Buy_Now": "Купете сега",
    "Dont_Use_Any": "Не използвайте никакви",
    "settlement_confirm": "Потвърдете",
    "settlement_tips": "Потвърдете",
    "flowDetail_unsubscribe": "Отпишете се",
    "flowDetail_unsubscribed": "Отписан",
    "flowDetail_isCancelPackage": "Отпишете този пакет?",
    "flowDetail_confirmAgreementUnsubscribe": "Не можете да имате страхотната сделка след отписване. Сигурни ли сте, че искате да се отпишете?",
    "flowDetail_cancel": "Отказ",
    "flowDetail_cancelSuccess": "Отпишете се успешно",
    "packages_detail_promotion": "Промоция",
    "orderTips":{
        "iDay" : "ден",
        "iDays" : "дни",
        "iMonth" : "месец",
        "iMonths" : "месеци",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol При първата ви покупка, Платете %@money/%@periodSymbol по -късно, Можете да се отпишете по всяко време",
        'Monthly_discount':"Запазете %@saveMoney всеки %@period! Можете да се отпишете по всяко време",
        'Ordinary_monthly_package':"Сигурен, лесен и удобен начин. Можете да се отпишете по всяко време",
        "AlreadyPurchased":'За съжаление в момента можете да се абонирате само за един пакет от данни. Моля, отпишете се от “%@” и се абонирайте по -късно към всеки пакет, който желаете, след като изтече.',
        "Contract_recommendation_First":'<label>С AutoPay Service, при първата си покупка, платете само</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Можете да се отпишете по всяко време'
        +'<a class="btn">Абонирайте се ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>С услугата за автоматично плащане плати само</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Можете да се отпишете по всяко време'
        +'<a class="btn">Абонирайте се ></a></p>',
        "Contract_recommendation_General":"<label>С услуга за автоматично затихване</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Сигурен, лесен и удобен начин. Можете да се отпишете по всяко време'
        +'<a href="javascript:;" class="btn">Абонирайте се ></a></p>',
        'BanlanceDoubleCheck':'Сигурни ли сте, че искате да платите с баланс?',
    },
    feedback: {
        title: "обратна връзка",
        placeholder: "Моля, въведете страната, която искате да посетите, или други въпроси и ние ще отговорим на вашите нужди възможно най -скоро!",
        submit: "Изпратете",
        submit_success: "Изпратено успешно",
        other_opinions: "Други мнения"
    },
    view_country_input: 'Моля, въведете акаунта си',
    "select_package": {
        "title": "Изберете Данни",
        "allPackage": "Всички Данни",
        "type": "Тип",
        "flow": "Данни",
        "month_package": "Месечен План",
        "flow_package": "Пакет Данни",
        "time": "Продължителност",
        "period": "Цикъл",
        "auto_debit": "Инфо Автодебит",
        "auto_subscribe": "Авто-Продължаване",
        "detail": "Детайли на Данните",
        "carrier": "Поддържани Оператори",
        "country": "Покрити страни",
        "notice": "Ръководство за покупка"
    }
}